export const EDiffusionModelsFilterType = {
  ALL: 'ALL',
  // ...EDiffusionModelType, #todo: review
};
